import React from "react";
import { QRCodeSVG } from "qrcode.react";
import {
  calculateLogoCenter,
  QR_CONFIG,
} from "../../constants/qrCodeConstants";

interface QRCodeRendererProps {
  value: string;
  size?: number;
  color?: string;
  withLogo?: boolean;
  logoUrl?: string;
  id?: string;
  className?: string;
}

const QRCodeRenderer: React.FC<QRCodeRendererProps> = ({
  value,
  size = QR_CONFIG.DISPLAY_SIZE,
  color = QR_CONFIG.STYLE.DEFAULT_COLOR,
  withLogo = false,
  logoUrl,
  id,
  className = "",
}) => {
  const { x: logoX, y: logoY } = calculateLogoCenter(size);

  return (
    <div
      id={id}
      className={`qr-code-container ${className}`}
      style={{
        position: "relative",
        width: size,
        height: size,
        display: "inline-block",
      }}
    >
      <QRCodeSVG
        value={value}
        size={size}
        fgColor={color}
        bgColor={QR_CONFIG.STYLE.BACKGROUND_COLOR}
        level={QR_CONFIG.STYLE.ERROR_CORRECTION_LEVEL}
      />

      {withLogo && logoUrl && (
        <>
          <div
            className="logo-bg"
            style={{
              position: "absolute",
              top: `${logoY}px`,
              left: `${logoX}px`,
              width: `${QR_CONFIG.LOGO.TOTAL_SIZE}px`,
              height: `${QR_CONFIG.LOGO.TOTAL_SIZE}px`,
              backgroundColor: QR_CONFIG.LOGO.BACKGROUND_COLOR,
              zIndex: 9,
              transform: "none",
            }}
          />

          <img
            src={logoUrl}
            alt="Logo"
            className="logo-img"
            style={{
              position: "absolute",
              top: `${logoY + QR_CONFIG.LOGO.PADDING}px`,
              left: `${logoX + QR_CONFIG.LOGO.PADDING}px`,
              width: `${QR_CONFIG.LOGO.SIZE}px`,
              height: `${QR_CONFIG.LOGO.SIZE}px`,
              objectFit: "contain",
              zIndex: 10,
              transform: "none",
            }}
          />
        </>
      )}
    </div>
  );
};

export default QRCodeRenderer;
